var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 137.678,
    height: 181,
    viewBox: "0 0 137.678 181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2687",
    "data-name": "Rectangle 2687",
    width: 118.678,
    height: 181,
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_314",
    x: 0,
    y: 4,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1804",
    "data-name": "Group 1804",
    transform: "translate(-386 -997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1571",
    "data-name": "Group 1571",
    transform: "translate(405 997)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2686",
    "data-name": "Rectangle 2686",
    width: 118.678,
    height: 181,
    rx: 10,
    transform: "translate(0)",
    fill: "#587be1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1570",
    "data-name": "Group 1570",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1569",
    "data-name": "Group 1569",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2904",
    "data-name": "Path 2904",
    d: "M40.271,239.733l-14.767,41H55.037c.024-.049,8.742-51.265,6.589-58.373-2.194-7.244-9.647-30.105-9.722-30.336a.538.538,0,0,0-.619-.36c-.172.035-4.227.9-4.513,4.312-.212,2.523-.109,11.394-.063,14.63-2.233-1.929-8.079-7.329-10.729-13.106a.534.534,0,0,0-.712-.265.526.526,0,0,0-.289.358.543.543,0,0,0-.2-.063c-.014,0-.026.006-.04.005.471-.754,1.029-1.625,1.638-2.528a6.758,6.758,0,0,0,1.36-5.388,5.413,5.413,0,0,0-2.452-3.24.453.453,0,0,0-.049-.015l.171-.209c3.333-4.016-.643-9.833-.814-10.079a.539.539,0,0,0-.873-.015l-3.824,5.105c-.119-1.443-.617-6.672-1.676-8.322-1.208-1.883-5.082-3.263-5.246-3.322a.538.538,0,0,0-.716.5l-.067,21.2a.518.518,0,0,0,.041.175l-2.51,3.35a.539.539,0,0,0-.1.386s2.911,23.576,2.974,23.654Z",
    transform: "translate(-11.538 -99.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2905",
    "data-name": "Path 2905",
    d: "M29.138,196.221,21.287,206.7l-2.5,3.344",
    transform: "translate(-11.052 -115.46)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2906",
    "data-name": "Path 2906",
    d: "M22.056,227.571C24.88,223.781,33.1,212.8,35.868,209.658",
    transform: "translate(-12.978 -123.367)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2907",
    "data-name": "Path 2907",
    d: "M32.878,246.04l10.059-9.922s2.623,3.649,1.538,6.219-5.465,7.436-5.465,7.436l1.514,5.581A20.163,20.163,0,0,1,52.8,262.916",
    transform: "translate(-19.346 -138.936)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2908",
    "data-name": "Path 2908",
    d: "M188.518,239.733l14.767,41H173.751c-.024-.049-8.742-51.265-6.589-58.373,2.194-7.244,9.647-30.105,9.722-30.336a.538.538,0,0,1,.619-.36c.172.035,4.227.9,4.513,4.312.212,2.523.109,11.394.063,14.63,2.233-1.929,8.079-7.329,10.729-13.106a.534.534,0,0,1,.712-.265.526.526,0,0,1,.289.358.543.543,0,0,1,.2-.063c.014,0,.026.006.04.005-.471-.754-1.029-1.625-1.638-2.528a6.758,6.758,0,0,1-1.36-5.388,5.413,5.413,0,0,1,2.452-3.24.453.453,0,0,1,.049-.015l-.171-.209c-3.333-4.016.643-9.833.814-10.079a.539.539,0,0,1,.873-.015l3.824,5.105c.119-1.443.617-6.672,1.676-8.322,1.208-1.883,5.082-3.263,5.246-3.322a.538.538,0,0,1,.716.5l.068,21.2a.518.518,0,0,1-.041.175l2.51,3.35a.539.539,0,0,1,.1.386s-2.911,23.576-2.975,23.654Z",
    transform: "translate(-98.16 -99.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2909",
    "data-name": "Path 2909",
    d: "M244.549,196.221,252.4,206.7l2.5,3.344",
    transform: "translate(-143.897 -115.46)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2910",
    "data-name": "Path 2910",
    d: "M246.692,227.571c-2.824-3.789-11.046-14.771-13.812-17.913",
    transform: "translate(-137.031 -123.367)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2911",
    "data-name": "Path 2911",
    d: "M227.141,246.04l-10.059-9.922s-2.623,3.649-1.538,6.219,5.465,7.436,5.465,7.436l-1.514,5.581a20.163,20.163,0,0,0-12.271,7.563",
    transform: "translate(-121.935 -138.936)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2912",
    "data-name": "Path 2912",
    d: "M75.012,75.682a28.694,28.694,0,0,1,35.914-28.256A27.882,27.882,0,0,1,130.948,66.55,28.825,28.825,0,0,1,118.31,99.837l.173,11.046-28.606.451L89.7,100.288A28.684,28.684,0,0,1,75.012,75.682",
    transform: "translate(-44.136 -27.376)",
    fill: "#fccc42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2913",
    "data-name": "Path 2913",
    d: "M128.977,129.423s-.6-26.432,1.7-34.141c.822-2.749,6.17-10.436,9.41-6.591s-9.971,17.488-17.011,9.282C118.853,93.047,116.3,76.834,122.033,78c3.423.7,7.028,19.694.412,22.147-8.834,3.275-13.6-5.115-13.988-7.912s9.534,2.335,10.467,12.223.424,25.541.424,25.541",
    transform: "translate(-63.812 -45.861)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2914",
    "data-name": "Path 2914",
    d: "M117,223.872l17.532-.272a5.537,5.537,0,0,0,5.45-5.624l-.24-15.082-28.6.445.24,15.086A5.537,5.537,0,0,0,117,223.872",
    transform: "translate(-65.393 -119.386)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    x1: 31.318,
    y2: 0.487,
    transform: "translate(44.092 90.5)",
    fill: "none",
    stroke: "#080717",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87",
    "data-name": "Line 87",
    x1: 31.318,
    y2: 0.487,
    transform: "translate(44.092 84.741)",
    fill: "none",
    stroke: "#080717",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 386, 997)",
    filter: "url(#Ellipse_314)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_314-2",
    "data-name": "Ellipse 314",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(9 10)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3262",
    "data-name": "Path 3262",
    d: "M2.516,0,2.5-10.88l1.19,1.19H.136L.119-11.9H5.236L5.253,0ZM8.891.136A1.617,1.617,0,0,1,7.727-.331a1.593,1.593,0,0,1-.484-1.2,1.538,1.538,0,0,1,.484-1.182,1.65,1.65,0,0,1,1.165-.451,1.642,1.642,0,0,1,1.173.451A1.552,1.552,0,0,1,10.54-1.53a1.607,1.607,0,0,1-.476,1.2A1.609,1.609,0,0,1,8.891.136Z",
    transform: "translate(410 1033)",
    fill: "#005465"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.e92ff033f79db53d3a2f28b7e9eeebe2.svg";
export { ForwardRef as ReactComponent };